import { render, staticRenderFns } from "./ParentRegisterByLink.vue?vue&type=template&id=3ecf1398&scoped=true"
import script from "./ParentRegisterByLink.vue?vue&type=script&lang=js"
export * from "./ParentRegisterByLink.vue?vue&type=script&lang=js"
import style0 from "./ParentRegisterByLink.vue?vue&type=style&index=0&id=3ecf1398&prod&scoped=true&lang=css"
import style1 from "./ParentRegisterByLink.vue?vue&type=style&index=1&id=3ecf1398&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecf1398",
  null
  
)

export default component.exports